export function deepEquals(thing, other) {
  return JSON.stringify(thing) === JSON.stringify(other);
}
export function deepFind(list, target) {
  for (const item of list) {
    if (deepEquals(item, target)) {
      return item;
    }
  }
  return null;
}